import React, { useState } from "react";
import Modal from "./Modal";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPalette, faCheck } from "@fortawesome/free-solid-svg-icons";
import "./CreateFolderModal.css"; // Reuse existing modal CSS

const folderColors = [
  "#2196F3", // Blue
  "#4CAF50", // Green
  "#FF9800", // Orange
  "#f44336", // Red
  "#9C27B0", // Purple
  "#00BCD4", // Cyan
  "#E91E63", // Pink
  "#607D8B", // Gray
];

const CreateComplianceFolderModal = ({ isOpen, onClose, onCreate }) => {
  const [folderName, setFolderName] = useState("");
  const [folderDescription, setFolderDescription] = useState("");
  const [folderColor, setFolderColor] = useState("#2196F3");

  const handleSubmit = (e) => {
    e.preventDefault();
    onCreate({
      name: folderName,
      description: folderDescription,
      color: folderColor,
    });
    // Reset form
    setFolderName("");
    setFolderDescription("");
    setFolderColor("#2196F3");
  };

  const handleClose = () => {
    setFolderName("");
    setFolderDescription("");
    setFolderColor("#2196F3");
    onClose();
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={handleClose}
      title="Create Compliance Folder"
    >
      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label>Folder Name *</label>
          <input
            type="text"
            placeholder="e.g., HIPAA Documents, Staff Certifications, Insurance & Licenses"
            value={folderName}
            onChange={(e) => setFolderName(e.target.value)}
            required
          />
        </div>
        <div className="form-group">
          <label>Description (Optional)</label>
          <textarea
            placeholder="Brief description of what documents this folder will contain..."
            rows="3"
            value={folderDescription}
            onChange={(e) => setFolderDescription(e.target.value)}
          ></textarea>
        </div>
        <div className="form-group">
          <label>
            <FontAwesomeIcon icon={faPalette} style={{ marginRight: "8px" }} />
            Folder Color
          </label>
          <div
            className="color-picker-grid"
            style={{
              display: "flex",
              gap: "10px",
              marginTop: "10px",
              flexWrap: "wrap",
            }}
          >
            {folderColors.map((color) => (
              <div
                key={color}
                onClick={() => setFolderColor(color)}
                style={{
                  width: "36px",
                  height: "36px",
                  borderRadius: "8px",
                  backgroundColor: color,
                  cursor: "pointer",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  border:
                    folderColor === color
                      ? "3px solid #333"
                      : "2px solid transparent",
                  transition: "all 0.2s ease",
                }}
              >
                {folderColor === color && (
                  <FontAwesomeIcon
                    icon={faCheck}
                    style={{ color: "white", fontSize: "14px" }}
                  />
                )}
              </div>
            ))}
          </div>
        </div>
        <div className="modal-actions">
          <button
            type="button"
            className="button cancel-button"
            onClick={handleClose}
          >
            CANCEL
          </button>
          <button type="submit" className="button create-button">
            CREATE FOLDER
          </button>
        </div>
      </form>
    </Modal>
  );
};

export default CreateComplianceFolderModal;
